import React, { useCallback } from "react"
import PropTypes from "prop-types"
import FormFieldset from "components/FormFieldset"
import GiftAidConfirmationModal from "components/GiftAidConfirmationModal"
import { Checkbox } from "components/common/Checkbox"
import GiftAidTooltip from "components/GiftAidTooltip"
import i18n from "lib/i18n"

const GiftAidCheckbox = ({ checked = false, onChange = () => {} }) => {
  const [modalOpen, setModalOpen] = React.useState(false)

  const modalConfirm = useCallback(() => {
    onChange({ giftAid: true })
    setModalOpen(false)
  }, [onChange, setModalOpen])
  const modalReject = useCallback(() => {
    onChange({ giftAid: false })
    setModalOpen(false)
  }, [onChange, setModalOpen])
  // Only open the confirmation modal when the checkbox is checked. We need confirmation
  // when the donor claims Gift Aid, not when they opt not to.
  const setGiftAid = useCallback(
    (event) => {
      onChange({ giftAid: event.target.checked })
      if (event.target.checked) {
        setModalOpen(true)
      }
    },
    [onChange, setModalOpen],
  )

  return (
    <>
      <FormFieldset>
        <Checkbox checked={checked} onChange={setGiftAid} value="true">
          <div className="ml-4 flex flex-col">
            <span className="text-sm">{i18n.t("donation.label.gift_aid_checkbox")}</span>
            <GiftAidTooltip />
          </div>
        </Checkbox>
      </FormFieldset>
      <GiftAidConfirmationModal open={modalOpen} onConfirm={modalConfirm} onReject={modalReject} />
    </>
  )
}

GiftAidCheckbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
}
export default React.memo(GiftAidCheckbox)
